import {Totals} from '../../../../../common/components/Totals/Totals';
import React from 'react';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {formatSignedAmount} from '../../../../../domain/utils/total.util';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';

export const GiftCardTotalsRow = () => {
  const localeKeys = useLocaleKeys();
  const {cartSummary, isCartSummaryUpdating} = useControllerProps().checkoutStore;
  const {isRTL} = useEnvironment();

  if (!cartSummary!.paymentSummary.giftCard || cartSummary!.paymentSummary.giftCard.redeemAmount.amount === 0) {
    return null;
  }

  return (
    <Totals.TotalsRow
      dataHook={TotalsSectionDataHooks.GiftCardRow}
      title={localeKeys.checkout.order_summary.totals.giftcard()}
      value={
        isCartSummaryUpdating
          ? () => <TotalUpdateSkeleton />
          : formatSignedAmount({amount: cartSummary!.paymentSummary.giftCard?.redeemAmount.formattedAmount, isRTL})
      }
    />
  );
};
